import Route from '@ember/routing/route';

export default class CurrentRoute extends Route {}
